export default __webpack_public_path__ + "static/chocpops-taste-2-mobile-6fbd6bd75474edc0b44af1fcf15dabe9.png";